module.exports = __webpack_public_path__ + "img/y-212.16072145.png";